import * as React from "react";
import { ChevronDown16Regular, ChevronUp16Regular } from "@fluentui/react-icons";
import { IScheduledJobState, IScheduledJobStateKeys } from "../../../../redux/types/IScheduledJobState";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IRepertoireField } from "../../../types/IRepertoireField";
import CombinedTextAndButtonDataInput from "../../textDataInput/CombinedTextAndButtonDataInput";
import CopyToClipboard from "../../text/CopyToClipboard";
import { validateCronExpression } from "../../../../util/cronValidation";

export interface IScheduledJobModalViewProps {
    fields: IRepertoireField[];
    noCallback?: () => void;
    yesCallback?: () => void;
    upsertScheduledJob: (schedule: IScheduledJobState,componentName?:string) => void;
    componentName: string;
    tab?: ITabReduxItem;
    changeData?: (value: any, fieldName: IScheduledJobStateKeys, componentName?: string) => void;
}

const ScheduledJobModalView: React.SFC<IScheduledJobModalViewProps> = ({ fields, yesCallback, noCallback, upsertScheduledJob, tab, componentName, changeData }) => {

    const [changesMade, setChangesMade] = React.useState(false);
    const [isAccordionActive, toggleAccordion] = React.useState(false);
    
    const onClickYes = () => {
        setChangesMade(false);
        yesCallback();
    }

    const onClickNo = () => {
        changeData([], "errorList");
        noCallback();
    }

    const typeOfJob = () =>{
        switch(componentName){
            case "CDAllocationScheduledJob":
                let alkScheduledJob =  tab.scheduledJobStateState.find(scheduledjob=>scheduledjob.type==="ALK")
                alkScheduledJob? alkScheduledJob.cronSchedule:tab.scheduledJobStateState.find(scheduledjob=>scheduledjob.type==="").type = "ALK"
                alkScheduledJob = tab.scheduledJobStateState.find(scheduledjob=>scheduledjob.type==="ALK")
                return alkScheduledJob.cronSchedule
                
            case "QAScheduledJob": 
                let QAScheduledJob =  tab.scheduledJobStateState.find(scheduledjob=>scheduledjob.type==="QA")
                QAScheduledJob? QAScheduledJob.cronSchedule:tab.scheduledJobStateState.find(scheduledjob=>scheduledjob.type==="").type = "QA"
                QAScheduledJob = tab.scheduledJobStateState.find(scheduledjob=>scheduledjob.type==="QA")
                return QAScheduledJob.cronSchedule
                
            default:
                console.error("Job doesn't exist")
        }   
        setChangesMade(false);
    }

    const onClickSetJobSchedule = () => {
        const jobType = componentName === "CDAllocationScheduledJob"
            ? "ALK"
            : componentName === "QAScheduledJob"
                ? "QA"
                : null;

        if (!jobType) {
            console.error("Job doesn't exist");
            return;
        }

        const job = tab.scheduledJobStateState.find(scheduledjob => scheduledjob.type === jobType);
        const validation = validateCronExpression(job?.cronSchedule ?? "");
        if (validation === "invalid") {
            changeData(["cronExpressionInvalidValidation"], "errorList", componentName);
            return;
        }
        if (validation === "tooFrequent") {
            changeData(["scheduleIntervalLessThanOneHourValidation"], "errorList", componentName);
            return;
        }

        changeData([], "errorList", componentName);
        upsertScheduledJob(job, componentName);
        setChangesMade(false);
    }

    const renderAccordionData = () => {
        if (isAccordionActive) {
            return (
                <div className="contentAccordion backgroundLightGray" style={{ padding: "10px" }} >
                    <div dangerouslySetInnerHTML={{ __html: (fields.find(f => f.name === "cronInfoHtml")?.data || "") }} />
                    <div>
                        {fields.find(f => f.name === "cronExample1")?.data}
                        <CopyToClipboard value={"0 * * * *"} />
                    </div>
                    <br/>
                    <div>
                        {fields.find(f => f.name === "cronExample2")?.data}
                        <CopyToClipboard value={"0 0 * * *"} />
                    </div>
                    <br/>
                    <div>
                        {fields.find(f => f.name === "cronExample3")?.data}
                        <CopyToClipboard value={"0 0 * * SAT"} />
                    </div>
                    <br/>
                </div>
            )
        }
    }

    const renderFields = () => {
        const filteredFields: IRepertoireField[] = fields.filter(f => f.fieldType !== null)
        let filteredSearchFieldsMapper = (searchField: IRepertoireField, index: number): React.ReactElement => {
            let reactElement: React.ReactElement = <></>;

            if ((searchField.name === 'cronSchedule'))
                reactElement =
                    <div key={index}>
                        <CombinedTextAndButtonDataInput
                            useEnterSubmit={false}
                            label={searchField.data}
                            fieldName={searchField.name}
                            changeData={(value, fieldName) => {
                                changeData(value, fieldName as IScheduledJobStateKeys, `${componentName}`);
                                changeData([], "errorList", componentName);
                                setChangesMade(true);
                            }}
                            value={typeOfJob()}
                            readOnly={false}
                            buttonAction={onClickSetJobSchedule}
                            buttonLabel={fields.find(f => f.name === "setJobSchedule").data}
                            isEnabled={changesMade}
                        />
                    </div>;

            return reactElement;
        };
        return filteredFields.map(filteredSearchFieldsMapper);
    }

    const jobTypeForComponent = () => {
        switch (componentName) {
            case "CDAllocationScheduledJob":
                return "ALK";
            case "QAScheduledJob":
                return "QA";
            default:
                return undefined;
        }
    }

    const currentScheduledJob = () =>
        tab?.scheduledJobStateState?.find(scheduledJob => scheduledJob.type === jobTypeForComponent());

    const showErrorMessages = () => {
        const errorList = currentScheduledJob()?.errorList ?? [];
        return errorList.map((message, index) => {
            const field = fields.find(f => f.name === message);
            const text = field?.data || message;
            return (
                <div className="col-md-12 alert alert-warning" role="alert" key={index}>
                    <div>{text}</div>
                </div>
            );
        });
    }

    const className = (!!noCallback !== !!yesCallback) ? "col-xs-12" : "col-xs-6";

    return (
        <div className="scheduledJobView">
            { (currentScheduledJob()?.errorList?.length ?? 0) > 0 && showErrorMessages() }

            { fields.find(f => f.name === "modalHeader")?.data }

            <div className="AccordionContainer">
                <div className={["itemAccordion", isAccordionActive ? "activeItem" : null, "justify-content-between"].join(" ")}>
                    <div onClick={() => toggleAccordion(!isAccordionActive)} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <span>{ fields.find(f => f.name === "cronInfoDropdownTitle")?.data }</span>
                        {isAccordionActive
                            ? <ChevronUp16Regular title="Expand section" className="icon" />
                            : <ChevronDown16Regular title="Expand section" className="icon" />}
                    </div>
                </div>
                <div>{renderAccordionData()}</div>
                <br/>
            </div>

            <div className="row">
                {renderFields()}
            </div>

            {(!!noCallback || !!yesCallback) && <div>
                <div className="button-separator"></div>
                <div className="yesNoPromptView">
                    <div className="row">
                        {!!noCallback && <div className={className}>
                            <button className="button btn-defaultSecondary btn-sm pull-left" onClick={onClickNo}>
                                {fields.find(f => f.name === "noButton").data}
                            </button>
                        </div>}
                        {!!yesCallback && <div className={className}>
                            <button className="button btn-defaultPrimary btn-sm pull-right" onClick={onClickYes}>
                                {fields.find(f => f.name === "yesButton").data}
                            </button>
                        </div>}
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default ScheduledJobModalView;